import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function QueryQualifyDateList(props) {
  const ls = require("localstorage-ttl");

  const displayFormat = "DD/MM/YYYY";
  const dbFormat = "YYYY-MM-DD";
  var moment = require("moment");

  const [isLoading, setLoading] = useState(false);
  const [dates, setDates] = useState([]);

  useEffect(() => {
    const token = JSON.parse(ls.get("jwt"));
    const headerRequest = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const datesGet = () => {
      const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

      setLoading(true);
      const dateTo = moment().format(dbFormat);
      axios
        .get(
          `${API_URL}/examinations?populate=*&sort[0]=date%3Adesc&sort[1]=rank%3Aasc&filters[date][$lte]=${dateTo}`,
          headerRequest
        )
        .then((res) => setDates(res.data.data))
        .catch((error) => {
          console.log("Error with examinations:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    datesGet();
  }, []);

  const renderData = (
    <Table striped hover size="sm" responsive="sm">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Modalidad</th>
          <th>Grado</th>
          <th className="d-none d-lg-table-cell">Examinador</th>
          <th className="d-none d-lg-table-cell">Lugar</th>
          <th>Acción</th>
        </tr>
      </thead>
      <tbody>
        {dates.length < 1 ? (
          <tr>
            <td colSpan="6" align="center">
              No hay fechas disponibles.
            </td>
          </tr>
        ) : (
          dates.map((e) => (
            <tr key={e.id}>
              <td align="center">
                {moment(e.attributes.date).format(displayFormat)}
              </td>
              <td align="center">{e.attributes.mode}</td>
              <td align="center">{e.attributes.rank}</td>
              <td align="left" className="d-none d-lg-table-cell">
                {e.attributes.examiner.data.attributes.name}
              </td>
              <td align="left" className="d-none d-lg-table-cell">
                {e.attributes.place?.replace(
                  /(?:https?|ftp):\/\/[\n\S]+/g,
                  "..."
                )}
              </td>
              <td align="center">
                <Link to={`/queryQualify/${e.id}`}>
                  <Button size="sm" variant="success">
                    VER
                  </Button>
                </Link>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>REPORTE DE FECHAS PASADAS</h4>
      <p>Seleccione la fecha en la cual desea consultar exámenes</p>
      {isLoading ? <Spinner animation="border" /> : renderData}
    </Container>
  );
}
